import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../core/form/Button';
import Dialog from '../../../core/layout/Dialog';

const ConfirmDialog = (props) => (
  <Dialog
    title={props.title}
    onCancel={props.onDiscard}
    actions={[
      <Button
        key="confirmButton"
        loading={props.loading}
        type="danger"
        label={props.confirmLabel}
        onClick={() => props.onConfirm()}
      />,
      <Button
        key="discardButton"
        loading={props.loading}
        type="default"
        label={props.discardLabel}
        onClick={() => props.onDiscard()}
      />,
    ]}
    isOpen={props.isOpen}
  >
    {props.message}
  </Dialog>
);

ConfirmDialog.propTypes = {
  loading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  discardLabel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
};

ConfirmDialog.defaultProps = {
  loading: false,
};

export default ConfirmDialog;
